import doRequest from "services/helpers";
import { getToken } from "./tokenAuth";

export const requestGetUserPerRole = async () => {
    const [result, err] = await doRequest(
        "/LeerUsuario", "GET", null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1) 
        return null;
    return data.data.usuarios.map(({ 
        codigoUsuario, nombres, 
        nombreRol 
    }) => {
        return {
            id: codigoUsuario,
            name: nombres.trim(),
            role: nombreRol
        };
    });
}
export const requestGetPermissionsByUserId = async codigoUsuario => {
    const [result, err] = await doRequest(
        "/UsuarioPermiso", "POST",
        {
            codigoUsuario
        }, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1) 
        return null;
    const { usuario, listaModulosPermisos } = data.data;
    return {
        user: {
            name: `${usuario.nombres} ${usuario.apellidos}`,
            role: {
                id: usuario.idRol,
                name: usuario.nombreRol
            }
        },
        modules: listaModulosPermisos.map(({ id, permisos }) => {
            return {
                id,
                permissions: permisos
            }
        })
    };
}